import { z } from "zod";
import { ScheduleApplicationStatus } from "@common/types/domains/accounting/schedule";

export const documentLineScheduleSchema = z.object({
    scheduleApplicationId: z.string().uuid(),
    scheduleTemplateId: z.string().uuid(),
    scheduleName: z.string(),
    // Last recognition period's date; null until periods exist.
    termEnd: z.string().date().nullable(),
    // Applied amount less recognition periods dated up to today, whether or
    // not posted; the Schedule column's "left".
    remainingAmount: z.number(),
    status: z.nativeEnum(ScheduleApplicationStatus),
});

export type DocumentLineSchedule = z.infer<typeof documentLineScheduleSchema>;

export const documentScheduleBaseSchema = z.object({
    scheduleApplicationId: z.string().uuid().nullable(),
    scheduleTemplateId: z.string().uuid().nullable(),
    scheduleName: z.string().nullable(),
    // Whole-document application only; null for line-scoped ("lines") scope.
    termEnd: z.string().date().nullable(),
    remainingAmount: z.number().nullable(),
    // Whole-document application only; null for line-scoped ("lines") scope.
    status: z.nativeEnum(ScheduleApplicationStatus).nullable(),
    scheduledLineIds: z.array(z.string().uuid()),
});
